import React from 'react';
import FormPage from '../shared/FormPage';
import useCreateCompanyStore from '../../stores/createCompanyStore';

// Mirrors company_info.onboarding.PRIMARY_GOAL_CHOICES on the backend. The
// answer picks the feature preset a new company starts with and which setup
// steps apply; it can be changed later from the Onboarding Center or the
// setup assistant. Exported so the review page labels the choice from the
// same list.
export const PRIMARY_GOAL_OPTIONS = [
  {
    value: 'scheduling',
    title: 'Scheduling and labor',
    description: 'Schedules, approvals, forecasts, and labor reporting. Best for operators and GMs.',
  },
  {
    value: 'training',
    title: 'Training and team onboarding',
    description: 'Training tracks, team records, and company files. Scheduling stays off until you turn it on.',
  },
  {
    value: 'both',
    title: 'Both',
    description: 'Everything above, ready on day one.',
  },
];

export const PRIMARY_GOAL_LABELS = Object.fromEntries(
  PRIMARY_GOAL_OPTIONS.map((option) => [option.value, option.title])
);

const StartingModulesPage = () => {
  const { formData, setFormData, isStepValid, nextStep, previousStep } = useCreateCompanyStore();

  return (
    <FormPage
      title="What do you want up and running first?"
      subtitle="Rightwork turns on the right features and tailors setup to it. You can change this anytime."
      inputType="none"
      onNext={nextStep}
      onPrevious={previousStep}
      isValid={isStepValid(2)}
    >
      <div className="space-y-3" role="radiogroup" aria-label="Starting modules">
        {PRIMARY_GOAL_OPTIONS.map((option) => {
          const selected = formData.primaryGoal === option.value;
          return (
            <button
              key={option.value}
              type="button"
              role="radio"
              aria-checked={selected}
              onClick={() => setFormData('primaryGoal', option.value)}
              className={`w-full rounded-3xl border-2 p-5 text-left transition-all ${
                selected
                  ? 'border-violet-700 bg-violet-50'
                  : 'border-slate-200 bg-white hover:border-violet-200 hover:bg-violet-50/40'
              }`}
            >
              <p className="text-lg text-slate-900">{option.title}</p>
              <p className="mt-2 text-sm text-slate-600">{option.description}</p>
            </button>
          );
        })}
      </div>
    </FormPage>
  );
};

export default StartingModulesPage;
